import React from 'react';
import './LibraryIntroduction.css';

const LibraryIntroduction = () => {
  return (
    <section id="library-introduction">
      <div id="library-intro-container">
        <div id="library-intro-content">
          <div id="library-intro-header">
            <h2 className="library-intro-title">Central Library</h2>
            <p className="library-intro-subtitle">
              Empowering Academic Excellence Through Knowledge Access
            </p>
          </div>
          
          <div id="library-intro-body">
            <div className="library-intro-text">
              <p className="library-intro-paragraph">
                The Central Library at Rayalaseema University serves as a 
                cornerstone in bolstering the institution's academic endeavors, 
                providing vital support to its teaching and research initiatives.
                 With a steadfast commitment to meeting the diverse informational 
                 needs of its users, the library stands as a beacon of knowledge
                  dissemination and scholarly engagement.

              </p>
              
              <p className="library-intro-paragraph">
               Spread across four meticulously designed floors spanning 
               approximately <strong>46,814 square feet</strong>, the Central Library embodies 
               excellence in its infrastructure and resources. 
               It houses a myriad of specialized sections, including the 
               Reference Section, Reading Rooms, and Acquisition & Technical 
               Section, each meticulously curated to facilitate seamless access 
               to a vast array of scholarly materials.
              </p>
              
              <p className="library-intro-paragraph">
                As of <strong>December 31, 2023</strong>, the library boasts an extensive 
                collection comprising <strong>44,225</strong> meticulously curated volumes, 
                encompassing a wide spectrum of academic disciplines. 
                Additionally, it houses a wealth of bound volumes of journals, 
                magazines, theses, reports, and other scholarly works, further 
                enriching its archival holdings.
              </p>

              <p className="library-intro-paragraph">
                Catering to a diverse and discerning user community, 
                the Central Library remains steadfast in its mission to 
                uphold the highest standards of academic excellence. 
                Its dynamic and thoughtfully organized layout ensures 
                optimal accessibility, fostering an environment conducive 
                to immersive learning and scholarly exploration for all patrons.

              </p>
            </div>
            
            <div id="library-intro-features">
              <h3 className="library-features-title">Key Features</h3>
              <div className="library-features-grid">
                
                
                <div className="library-feature-item">
                  <div className="library-feature-icon">
                    <i className="fas fa-user-graduate"></i>
                  </div>
                  <div className="library-feature-content">
                    <h4>Learning Support</h4>
                    <p>Help students, scholars, and faculty reach their full potential by providing supportive learning environments and information</p>
                  </div>
                </div>
                
                <div className="library-feature-item">
                  <div className="library-feature-icon">
                    <i className="fas fa-graduation-cap"></i>
                  </div>
                  <div className="library-feature-content">
                    <h4>Academic Programs</h4>
                    <p>Provide reading facilities and services to support formal programs, 
                      Keep faculty members informed of the latest developments in their fields
                    </p>
                  </div>
                </div>
                
                <div className="library-feature-item">
                  <div className="library-feature-icon">
                    <i className="fas fa-award"></i>
                  </div>
                  <div className="library-feature-content">
                    <h4>Research Excellence</h4>
                    <p>Enhance the university's status as a major research institution and center of excellence in higher learning</p>
                  </div>
                </div>
                
                <div className="library-feature-item">
                  <div className="library-feature-icon">
                    <i className="fas fa-globe"></i>
                  </div>
                  <div className="library-feature-content">
                    <h4>Global Information</h4>
                    <p>Provide researchers with global information to support qualitative research and education</p>
                  </div>
                </div>
                
                <div className="library-feature-item">
                  <div className="library-feature-icon">
                    <i className="fas fa-network-wired"></i>
                  </div>
                  <div className="library-feature-content">
                    <h4>Library Collaboration</h4>
                    <p>Collaborate with other libraries for resource development and networking</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LibraryIntroduction;